import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { IconComponent } from '../../ui/icon/icon.component';
import { IconButtonComponent } from '../../ui/icon-button/icon-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-popin-layout',
  templateUrl: './popin-layout.component.html',
  styleUrls: ['./popin-layout.component.scss'],
  imports: [IconComponent, IconButtonComponent, TranslatePipe],
})
export class PopinLayoutComponent extends AbstractComponent {
  @Input() public icon?: string;
  @Input() public label?: string;

  @Output() public readonly dismiss: EventEmitter<void>;

  public constructor() {
    super();

    this.dismiss = new EventEmitter<void>();
  }
}
